import clsx from "clsx";
import React from "react";

interface SpinProps {
  spinning?: boolean;
  children?: React.ReactNode;
  className?: string;
}

const Spin: React.FC<SpinProps> = ({
  spinning = true,
  children,
  className,
}) => {
  return (
    <div className={clsx("relative", className)}>
      {children}
      {spinning && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/80">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-100 border-t-blue-500" />
        </div>
      )}
    </div>
  );
};

export default Spin;
